import { getGlobalStates } from "userful-chronos-app-common-js/dist/globalstates/globalStates";

import {
    REQUEST_LIST_ICE_SERVERS,
    REQUEST_ADD_ICE_SERVER,
    REQUEST_UPDATE_ICE_SERVER,
    REQUEST_REMOVE_ICE_SERVER,
    REQUEST_DEFAULT_ICE_SERVER,
} from "userful-chronos-app-common-js/dist/message/messageTypeDefinitions/spaces/iceMsgDefinitions";
import { SpacesIceServer, SpacesIceServerID } from "userful-chronos-app-common-js/dist/models/spaces/ice";
import "./iceMsgReciever";

export const requestListIceServers = () => {
    getGlobalStates().eventBus.sendMsg(REQUEST_LIST_ICE_SERVERS);
};

export const requestAddIceServer = (payload: SpacesIceServer) => {
    getGlobalStates().eventBus.sendMsg(REQUEST_ADD_ICE_SERVER, payload);
};

export const requestUpdateIceServer = (payload: SpacesIceServer) => {
    getGlobalStates().eventBus.sendMsg(REQUEST_UPDATE_ICE_SERVER, payload);
};

export const requestRemoveIceServer = (payload: SpacesIceServerID) => {
    getGlobalStates().eventBus.sendMsg(REQUEST_REMOVE_ICE_SERVER, payload);
};

export const requestDefaultIceServer = () => {
    getGlobalStates().eventBus.sendMsg(REQUEST_DEFAULT_ICE_SERVER);
};
